<template>
<b-navbar class="header d-print-none">
  <b-nav>
    <b-nav-item>
      <a class="d-md-down-none px-2" href="#" @click="toggleSidebarMethod" v-b-tooltip.html.hover title="Turn on/off <br> sidebar <br> collapsing">
        <i class='fas fa-bars fa-lg' />
      </a>
      <a class="fs-lg d-lg-none" href="#" @click="switchSidebarMethod">
        <span class="rounded rounded-lg bg-gray text-white d-md-none">
          <i class="fas fa-bars fa-lg" />
        </span>
        <i class="fas fa-bars fa-lg d-sm-down-none ml-4" />
      </a>
    </b-nav-item>
  </b-nav>
  <b-nav class="ml-auto">
    <b-navbar-nav>
  <b-nav-form >
    <div>
      <a :href="userProfileUrl" target="_blank">
        <span class="navigationLinks fw-semi">{{ retrieveUserName() }}</span>
      </a>
      <div @click="logout">
        <span class="navigationLinks fw-semi">Log out</span>
      </div>
    </div>
    <b-nav-item>
      <a :href="userProfileUrl" target="_blank">
        <img class="ml-2 w-8 h-8 rounded-full cursor-pointer" src="/images/user30x30.png" alt="user profile" @click="navigateToUserProfile" />
      </a>
    </b-nav-item>
  </b-nav-form>
</b-navbar-nav>
  </b-nav>
</b-navbar>
</template>

<script>
import {
  mapGetters,
  mapState,
  mapActions
} from 'vuex';

import $ from 'jquery';
import Vue from "vue";

export default {
  name: 'Headed',
  components: {},
  computed: {
    ...mapState('layout', {
      sidebarClose: state => state.sidebarClose,
      sidebarStatic: state => state.sidebarStatic,
    }),
    ...mapGetters('authentication', ['jwtData']),
    userProfileUrl() {
      return Vue.prototype.$keycloak.createAccountUrl();
    },
  },
  methods: {
    ...mapActions('layout', ['toggleSidebar', 'switchSidebar', 'changeSidebarActive']),
    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      } else {
        this.switchSidebar(false);
        const paths = this.$route.fullPath.split('/');
        paths.pop();
        this.changeSidebarActive(paths.join('/'));
      }
    },
    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      } else {
        this.toggleSidebar();
        const paths = this.$route.fullPath.split('/');
        paths.pop();
        this.changeSidebarActive(paths.join('/'));
      }
    },
    logout() {
      Vue.prototype.$keycloak.logoutFn()
      this.$router.push('/login');
    },
    navigateToUserProfile() {
      window.open(this.userProfileUrl, '_blank');
    },
    retrieveUserName() {
      return Vue.prototype.$keycloak.fullName
    },
  },
  created() {
    if (window.innerWidth > 576) {
      setTimeout(() => {
        const $chatNotification = $('#chat-notification');
        $chatNotification.removeClass('hide').addClass('animated fadeIn')
          .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', () => {
            $chatNotification.removeClass('animated fadeIn');
            setTimeout(() => {
              $chatNotification.addClass('animated fadeOut')
                .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd' +
                  ' oanimationend animationend', () => {
                    $chatNotification.addClass('hide');
                  });
            }, 6000);
          });
        $chatNotification.siblings('#toggle-chat')
          .append('<i class="chat-notification-sing animated bounceIn"></i>');
      }, 4000);
    }
  },
};

</script>

<style src="./Header.scss" lang="scss" scoped />
